"use client";

import {ManageBookingItem} from "@/types/booking";
import {AiOutlineFileSearch} from "react-icons/ai";
import {Card} from "./card";

const ongoingDummyCards: ManageBookingItem[] = [
  {
    name: "Demo User 1",
    image: "/images/avatar.png",
    bookingId: 2001,
    vehicleName: "TN01A9934",
    bookingTime: new Date("2026-05-28T09:00:00").getTime(),
    driverName: "John Driver",
    driverEmpId: "SAMP062",
    pickupPoint: "KG Cinemas Stop",
    dropPoint: "Test Institute Branch 1"
  },
  {
    name: "Demo User 2",
    image: "/images/avatar.png",
    bookingId: 2002,
    vehicleName: "TN38DE2312",
    bookingTime: new Date("2026-05-28T10:00:00").getTime(),
    driverName: "Arun Driver",
    driverEmpId: "SAMP063",
    pickupPoint: "Hope College",
    dropPoint: "NeoSay Campus"
  }
];

export const OnGoing = ({
  filterData
}: {
  filterData: ManageBookingItem[] | null;
}) => {
  const cardsToRender =
    filterData && filterData.length > 0 ? filterData : ongoingDummyCards;
  return (
    <>
      <div className="grid grid-cols-4 gap-3 p-3">
        {cardsToRender.map((b: ManageBookingItem) => (
          <Card key={b.bookingId} b={b} statusType={1} />
        ))}
        {!filterData && (
          <div className="col-span-full flex min-h-[260px] w-full flex-col items-center justify-center text-center">
            {/* Icon */}
            <div className="mb-4">
              <AiOutlineFileSearch size={48} className="" />
            </div>

            {/* Title */}
            <h2 className="text-lg font-semibold text-gray-800">
              No record found
            </h2>

            {/* Description */}
            <p className="mt-1 text-sm text-gray-500">
              Please adjust the name of your search, or there is no data
              available.
            </p>
          </div>
        )}
      </div>
    </>
  );
};
